export { QrCode } from './QrCode.component.jsx';
